import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Crosshair, ArrowRight } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (e) {
      setErr(e.response?.data?.detail || "Request failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6">
      <div className="w-full max-w-sm" data-testid="forgot-page">
        <div className="flex items-center gap-3 mb-10">
          <img src="/rd-logo.jpeg" alt="" className="w-10 h-10 rounded-md object-cover" />
          <span className="font-heading text-2xl font-black tracking-tight">RD <span className="text-[#FF3B30]">SmartMetrics</span></span>
        </div>
        <div className="overline mb-2">// recover access</div>
        <h2 className="font-heading text-4xl font-black uppercase mb-8">Reset Password</h2>

        {!result && (
          <form onSubmit={submit} data-testid="forgot-form">
            {err && <div className="mb-4 px-3 py-2 border border-[#FF3B30]/40 text-[#FF3B30] text-sm">{err}</div>}
            <label className="block mb-8">
              <span className="overline block mb-2">Email</span>
              <input
                data-testid="forgot-email"
                type="email"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:border-[#FF3B30]"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              data-testid="forgot-submit"
              className="w-full bg-[#FF3B30] hover:bg-[#D92B22] text-white font-bold uppercase tracking-[0.18em] py-3 text-sm flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {busy ? "Sending…" : <>Send Reset Link <ArrowRight size={14} /></>}
            </button>
          </form>
        )}

        {result && (
          <div className="card-tactical p-5 text-sm" data-testid="forgot-result">
            <div className="overline mb-2">// request received</div>
            <p className="text-[#E5E5E5] mb-2">
              If <span className="font-mono text-white">{email}</span> matches an account on file,
              we&apos;ve sent a password-reset link to that inbox.
            </p>
            <p className="text-[#A1A1AA] text-xs leading-relaxed">
              The link expires in <b>1 hour</b> and can be used only once.
              Don&apos;t see it? Check your spam folder, then{" "}
              <button
                onClick={() => setResult(null)}
                data-testid="forgot-try-again"
                className="underline text-white hover:text-[#FF3B30] inline"
              >
                try again with a different email
              </button>.
            </p>
          </div>
        )}

        <div className="mt-6 text-xs text-[#A1A1AA]">
          Remember it? <Link to="/login" className="text-white underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
